import React, { useState } from 'react';
import { MessageSquare, Plus, Calendar, Clock, User, AlertCircle } from 'lucide-react';

const TicketsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  const [showNewTicketForm, setShowNewTicketForm] = useState(false);
  const [newTicket, setNewTicket] = useState({
    subject: '',
    message: '',
    priority: 'عادي'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // سيتم إرسال التذكرة إلى الباك إند
    alert('تم إرسال التذكرة بنجاح! سيتم الرد عليكم قريباً');
    setShowNewTicketForm(false);
    setNewTicket({ subject: '', message: '', priority: 'عادي' });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-[#EC4899] to-[#F472B6] rounded-xl flex items-center justify-center">
            <MessageSquare className="w-7 h-7 text-white" strokeWidth={2.5} />
          </div>
          <h2 className="text-3xl font-black  style={{ color: primaryColor }}">تذاكر الدعم</h2>
        </div>
        <button 
          onClick={() => setShowNewTicketForm(!showNewTicketForm)}
          className="px-6 py-3 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-xl transition-colors flex items-center gap-2 font-bold shadow-lg hover:shadow-xl"
        >
          <Plus className="w-5 h-5" />
          <span>تذكرة جديدة</span>
        </button>
      </div>

      {/* نموذج تذكرة جديدة */}
      {showNewTicketForm && (
        <div className="mb-8 border-2 border-[#C8A870] rounded-xl p-6 bg-gradient-to-br from-amber-50 to-white">
          <h3 className="text-xl font-black  style={{ color: primaryColor }} mb-4">إنشاء تذكرة دعم جديدة</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">موضوع التذكرة</label>
              <input
                type="text"
                value={newTicket.subject}
                onChange={(e) => setNewTicket({...newTicket, subject: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#C8A870] focus:outline-none font-semibold"
                placeholder="مثال: استفسار عن موعد الجلسة القادمة"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">الأولوية</label>
              <select
                value={newTicket.priority}
                onChange={(e) => setNewTicket({...newTicket, priority: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#C8A870] focus:outline-none font-bold"
              >
                <option value="عادي">عادي</option>
                <option value="عاجل">عاجل</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">الرسالة</label>
              <textarea
                value={newTicket.message}
                onChange={(e) => setNewTicket({...newTicket, message: e.target.value})}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#C8A870] focus:outline-none font-semibold h-32 resize-none"
                placeholder="اكتب رسالتك هنا..."
                required
              />
            </div>
            <div className="flex gap-3">
              <button 
                type="submit"
                className="flex-1 px-6 py-3 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors font-bold"
              >
                إرسال التذكرة
              </button>
              <button 
                type="button"
                onClick={() => setShowNewTicketForm(false)}
                className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors font-bold"
              >
                إلغاء
              </button>
            </div>
          </form>
        </div>
      )}

      {/* قائمة التذاكر */}
      {caseData.clientTickets && caseData.clientTickets.length > 0 ? (
        <div className="space-y-4">
          {caseData.clientTickets.map((ticket) => (
            <div 
              key={ticket.id}
              className="border-2 border-gray-200 rounded-xl p-5 hover:border-[#EC4899] transition-all hover:shadow-lg bg-white cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3 flex-1">
                  <div 
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ background: `linear-gradient(to bottom right, ${ticket.statusColor}, ${ticket.statusColor}dd)` }}
                  >
                    <MessageSquare className="w-5 h-5 text-white" strokeWidth={2.5} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-black text-gray-900">{ticket.subject}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs text-gray-500 font-semibold">{ticket.ticketNumber}</span>
                      <span 
                        className="px-2 py-0.5 rounded-full text-xs font-bold"
                        style={{ 
                          backgroundColor: `${ticket.statusColor}20`,
                          color: ticket.statusColor
                        }}
                      >
                        {ticket.status}
                      </span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                        ticket.priority === 'عاجل' 
                          ? 'bg-red-100 text-red-700' 
                          : 'bg-gray-100 text-gray-700'
                      }`}>
                        {ticket.priority}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-blue-50 px-3 py-1 rounded-lg">
                  <MessageSquare className="w-4 h-4 text-blue-600" />
                  <span className="text-sm font-bold text-blue-600">{ticket.messages}</span>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Calendar className="w-4 h-4 text-gray-400" />
                  <span className="font-semibold">{ticket.createdDate}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Clock className="w-4 h-4 text-gray-400" />
                  <span className="font-semibold">{ticket.lastUpdate}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <User className="w-4 h-4 text-gray-400" />
                  <span className="font-semibold truncate">{ticket.assignedTo}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <MessageSquare className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد تذاكر دعم</p>
          <p className="text-sm mt-2">قم بإنشاء تذكرة جديدة للتواصل مع فريق وازن</p>
        </div>
      )}
    </div>
  );
};

export default TicketsSection;